import { Component, OnDestroy, Signal } from '@angular/core';
import { stages } from '../../compensation-for-losses.routes';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { EventForm } from './forms/event-form';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DatePickerComponent } from '../../../../../../common/date-picker/date-picker.component';
import { NgxMaskDirective } from 'ngx-mask';
import { updateApplication } from '../../../../../../store/actions/application.actions';
import {
  ExposedMapControlComponent
} from '../../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { InjuredPersonFormComponent } from './components/injured-person-form/injured-person-form.component';

@Component({
  selector: 'app-event-section',
  standalone: true,
  imports: [
    StagesComponent,
    CommonModule,
    SpinnerComponent,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    DatePickerComponent,
    NgxMaskDirective,
    ExposedMapControlComponent,
    InjuredPersonFormComponent
  ],
  providers: [EventForm],
  templateUrl: './event-section.component.html'
})
export class EventSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  constructor(
    public form: EventForm,
    private router: Router,
    private route: ActivatedRoute,
    private store$: Store
  ) {
  }

  public submitAndGoNext(): void {
    console.log(this.form.controls);
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.application()?.uuid || '',
        application: this.form.toWriteModel(),
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
